"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var Details_less_1 = __importDefault(require("./Details.less"));
var framer_motion_1 = require("framer-motion");
var Details = function (_a) {
    var selected = _a.selected, items = _a.items;
    var t = (0, react_i18next_1.useTranslation)().t;
    var videos = (0, react_1.useMemo)(function () {
        var _a, _b;
        return (_b = (_a = items.find(function (_a) {
            var date = _a.date;
            return date.day === (selected === null || selected === void 0 ? void 0 : selected.day);
        })) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
    }, [selected, items]);
    var getSelectedDate = function () {
        var _a, _b, _c;
        var year = (_a = selected === null || selected === void 0 ? void 0 : selected.year) !== null && _a !== void 0 ? _a : new Date().getFullYear();
        var month = (_b = selected === null || selected === void 0 ? void 0 : selected.month) !== null && _b !== void 0 ? _b : (new Date().getMonth() + 1);
        var day = (_c = selected === null || selected === void 0 ? void 0 : selected.day) !== null && _c !== void 0 ? _c : new Date().getDate();
        // default at 18:00 local time
        return new Date(year, month - 1, day, 18, 0, 0);
    };
    var formatGoogleDateRange = function (start, durationMinutes) {
        if (durationMinutes === void 0) { durationMinutes = 60; }
        var pad = function (n) { return String(n).padStart(2, '0'); };
        var toBasic = function (d) { return "".concat(d.getUTCFullYear()).concat(pad(d.getUTCMonth() + 1)).concat(pad(d.getUTCDate()), "T").concat(pad(d.getUTCHours())).concat(pad(d.getUTCMinutes())).concat(pad(d.getUTCSeconds()), "Z"); };
        var end = new Date(start.getTime() + durationMinutes * 60000);
        return "".concat(toBasic(start), "/").concat(toBasic(end));
    };
    var createIcsAndDownload = function (summary, description) {
        var start = getSelectedDate();
        var dt = function (d) { return d.toISOString().replace(/[-:]/g, '').replace(/\..+/, 'Z'); };
        var end = new Date(start.getTime() + 60 * 60000);
        var ics = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:-//SageStreams//Calendar Export//EN',
            'BEGIN:VEVENT',
            "DTSTAMP:".concat(dt(new Date())),
            "DTSTART:".concat(dt(start)),
            "DTEND:".concat(dt(end)),
            "SUMMARY:".concat(summary),
            "DESCRIPTION:".concat(description),
            'END:VEVENT',
            'END:VCALENDAR'
        ].join('\r\n');
        var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = "".concat(summary.replace(/\s+/g, '_'), ".ics");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    var openGoogleCalendar = function (summary, details) {
        var start = getSelectedDate();
        var dates = formatGoogleDateRange(start, 60);
        var url = "https://calendar.google.com/calendar/render?action=TEMPLATE&text=".concat(encodeURIComponent(summary), "&details=").concat(encodeURIComponent(details), "&dates=").concat(dates);
        window.open(url, '_blank');
    };
    return (react_1.default.createElement("div", { className: Details_less_1.default['details'] },
        videos.map(function (_a) {
            var id = _a.id, name = _a.name, season = _a.season, episode = _a.episode, deepLinks = _a.deepLinks;
            return (react_1.default.createElement(framer_motion_1.motion.div, { key: id, initial: { opacity: 0, y: 8 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.2 } },
                react_1.default.createElement(components_1.Button, { className: Details_less_1.default['video'], href: deepLinks.metaDetailsStreams },
                    react_1.default.createElement("div", { className: Details_less_1.default['actions'] },
                        react_1.default.createElement(components_1.Button, { className: Details_less_1.default['calendar-btn'], tabIndex: -1, onClick: function (e) { e.preventDefault(); e.stopPropagation(); createIcsAndDownload("".concat(name, " S").concat(season, "E").concat(episode), (deepLinks === null || deepLinks === void 0 ? void 0 : deepLinks.metaDetailsStreams) || ''); } },
                            react_1.default.createElement(react_2.default, { className: Details_less_1.default['calendar-icon'], name: 'calendar' })),
                        react_1.default.createElement(components_1.Button, { className: Details_less_1.default['calendar-btn'], tabIndex: -1, onClick: function (e) { e.preventDefault(); e.stopPropagation(); openGoogleCalendar("".concat(name, " S").concat(season, "E").concat(episode), (deepLinks === null || deepLinks === void 0 ? void 0 : deepLinks.metaDetailsStreams) || ''); } },
                            react_1.default.createElement(react_2.default, { className: Details_less_1.default['calendar-icon'], name: 'open' }))),
                    react_1.default.createElement("div", { className: Details_less_1.default['name'] }, name),
                    react_1.default.createElement("div", { className: Details_less_1.default['info'] },
                        "S",
                        season,
                        "E",
                        episode),
                    react_1.default.createElement(react_2.default, { className: Details_less_1.default['icon'], name: 'play' }))));
        }),
        !videos.length ?
            react_1.default.createElement("div", { className: Details_less_1.default['placeholder'] }, t('CALENDAR_NO_NEW_EPISODES'))
            :
                null));
};
exports.default = Details;
